import { colorFor } from "./colors";

const searchResultsFillPaint = {
  "fill-color": colorFor("smart-search-fill"),
  "fill-opacity": 0.65,
}

const searchResultsLinePaint = {
  "line-color": colorFor("smart-search-fill"),
  "line-width": 2.0
}

const parcelHoverFillPaint = {
  "fill-color": colorFor("parcel-hover-fill"),
  "fill-opacity": 0.6,
}

const parcelHoverLinePaint = {
  "line-color": colorFor("parcel-hover-line"),
  "line-width": 2.0
}

const parcelSelectFillPaint = {
  "fill-color": colorFor("parcel-select-fill"),
  "fill-opacity": 0.8,
}

const parcelSelectPdfFillPaint = {
  "fill-color": colorFor("parcel-select-fill"),
  "fill-opacity": 0.5,
}

const parcelSelectLinePaint = {
  "line-color": colorFor("parcel-select-line"),
  "line-width": 4.0
}

const setbackParcelFillPaint = {
  "fill-color": colorFor("setback-selection-parcel-fill"),
  "fill-opacity": 1.0,
}

const setbackBuildingFillPaint = {
  "fill-color": colorFor("setback-selection-fill"),
  "fill-opacity": 1.0,
}

const setbackLinePaint = {
  "line-color": colorFor("setback-selection-line"),
  "line-width": 4.0,
}

const buildingFillExtrusionPaint = {
  "fill-extrusion-color": {
    type: "identity",
    property: "color"
  },
  "fill-extrusion-height": {
    type: "identity",
    property: "height"
  },
  "fill-extrusion-base": {
    type: "identity",
    property: "base_height"
  },
  "fill-extrusion-opacity": 1.0,
  "fill-extrusion-vertical-gradient": false,
};

const parcelFootprintFillPaint = {
  "fill-color": colorFor("parcel-footprint"),
  "fill-opacity": 1.0,
};

const parcelFootprintLinePaint = {
  "line-blur": 1.0,
  "line-color": colorFor("parcel-footprint-line"),
  "line-dasharray": [3, 1, 1, 1],
  "line-width": 4,
};

const mapPinLayout = {
  "icon-image": "pin-map",
  "icon-anchor": "bottom"
}

const mapSmartSearchLayout = {
  "icon-image": "pin-map",
  "icon-anchor": "bottom",
  "icon-allow-overlap": true,
}

const drawnParcelFillPaint = {
  "fill-color": colorFor("drawn-parcel-fill"),
  "fill-opacity": 0.7
};

const drawnParcelLinePaint = {
  "line-color": colorFor("drawn-parcel-line"),
  "line-width": 2
};

const drawingPolygonStyle = [
  {
    "id": "fill",
    "type": "fill",
    "filter": [
      "any",
      ["!=", "mode", "draw_polygon"],
      ["==", "active", "false"]
    ],
    "paint": {
      "fill-color": colorFor("drawing-parcel-fill"),
      "fill-opacity": 0.6
    }
  },
  {
    "id": "border",
    "type": "line",
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": colorFor("drawing-parcel-line"),
      "line-width": 2
    }
  },
  {
    "id": "vertex-halo",
    "type": "circle",
    "filter": [
      "all",
      ["==", "active", "true"],
      [
        "any",
        ["==", "mode", "draw_polygon"],
        ["==", "mode", "direct_select"],
        ["==", "meta", "vertex"],
      ]
    ],
    "paint": {
      "circle-radius": 7,
      "circle-color": colorFor("drawing-parcel-vertex-halo")
    }
  },
  {
    "id": "vertex",
    "type": "circle",
    "filter": [
      "all",
      ["==", "active", "true"],
      [
        "any",
        ["==", "mode", "draw_polygon"],
        ["==", "mode", "direct_select"],
        ["==", "meta", "vertex"],
      ]
    ],
    "paint": {
      "circle-radius": 3.5,
      "circle-color": colorFor("drawn-parcel-fill")
    }
  },
  {
    "id": "vertex-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "active", "true"],
      ["==", "$type", "Point"],
      [
        "any",
        ["==", "mode", "draw_polygon"],
        ["==", "mode", "direct_select"],
        ["==", "meta", "vertex"],
      ]
    ],
    "paint": {
      "circle-radius": 3.5,
      "circle-color": colorFor("drawing-parcel-vertex-inactive")
    }
  },
  {
    "id": "midpoint-halo",
    "type": "circle",
    "filter": ["==", "meta", "midpoint"],
    "paint": {
      "circle-radius": 5,
      "circle-color": colorFor("drawing-parcel-line")
    }
  },
  {
    "id": "midpoint",
    "type": "circle",
    "filter": ["==", "meta", "midpoint"],
    "paint": {
      "circle-radius": 2.5,
      "circle-color": colorFor("drawn-parcel-fill")
    }
  },
];

export default {
  parcelHoverFillPaint,
  parcelHoverLinePaint,
  parcelSelectFillPaint,
  parcelSelectPdfFillPaint,
  parcelSelectLinePaint,
  setbackLinePaint,
  setbackParcelFillPaint,
  setbackBuildingFillPaint,
  buildingFillExtrusionPaint,
  parcelFootprintFillPaint,
  parcelFootprintLinePaint,
  mapPinLayout,
  drawingPolygonStyle,
  drawnParcelFillPaint,
  drawnParcelLinePaint,
  mapSmartSearchLayout,
  searchResultsFillPaint,
  searchResultsLinePaint,
}
